var React = require('react');

function Education (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"M29.105 5.838L15.607.122a1.568 1.568 0 0 0-1.214 0L.895 5.838A1.428 1.428 0 0 0 0 7.146c0 .566.35 1.08.895 1.308l3 1.243-.9.3v9.288c0 .395.335.715.75.715.413 0 .75-.32.75-.715v-8.402l10.498-3.744-1.83-.772-7.32 2.615L1.496 7.14l13.498-5.716L28.49 7.139l-13.497 5.716-5.49-2.315-2.01.714 6.885 2.858c.386.164.828.164 1.214 0l6.884-2.858v4.459c-2.063 1.772-4.722 2.785-7.498 2.858-2.777-.073-5.436-1.086-7.5-2.858v-4.459l-1.5.53v4.53l.45.414c2.348 2.039 5.39 3.201 8.565 3.272 3.164-.063 6.199-1.21 8.548-3.23l.45-.414V10.64l5.114-2.158c.544-.228.895-.741.895-1.307 0-.567-.35-1.08-.895-1.308v-.029z"}));
}

Education.defaultProps = {"width":"30","height":"20","viewBox":"0 0 30 20"};

module.exports = Education;

Education.default = Education;
